import CreateLocationController from './controller/CreateLocationController.js'
const template = require('./createLocation.component.tpl.pug')

const createLocation = {
  controller: CreateLocationController,
  template: template(),
}

export default createLocation
